import { COMMON_ERRORS } from 'modules/common/constants/errors.references';

export const ERROR_REFS = {
  ...COMMON_ERRORS,
  // add new error refs here
};

export const KEYWORD_ERRORS = {
  [ERROR_REFS.DUPLICATE_KEY]: {
    title: 'keyword:errors.duplicatedName',
    description: 'keyword:errors.duplicatedNameDescription',
  },
};
